import React  from 'react';
import Popup from './popups/popup';
import Survey from "./survey";
// import {imageUrl} from "../helpers/ApplicationHelper";
import {isMobile} from '../helpers/ApplicationHelper';

class SurveyPopup extends Popup {
    constructor(props) {
        super(props);
        this.state={title: props.title}
        this.isMobile = isMobile();
    }
    static initPopup(props = {}) {
        props.stopAnimation ? props.stopAnimation() : null;
        props = { ...props, displayThankYouIcon: true };
        Popup.initPopup.call(this, props);
    }

    title() {
        return this.state.title;
    }

    setTitleDesktop = (title) => {
        this.setState({title})
    }

    _onPopupClose() {
        if (this.props.stopAnimation) {
            this.props.stopAnimation();
        }
    }

    componentWillUnmount() {
        // Close popup in case user doesn't want to answer. clicks on "x" and popup's background
        if (this.props.onSurveyClose) {
            this.props.onSurveyClose();
        }
    }

    static hide() {
        window.dispatchEvent(new Event('popstate'));
    }

    content() {
        const {
            ObjectId,
            ObjectType,
            surveyToShow,
            setTitleMobile,
            onSurveyClose,
            showThankYouExp,
            isGemstone,
            defaultAnswers,
        } = this.props;

        return <div className='survey-popup'>
            <Survey ObjectId={ObjectId}
                ObjectType={ObjectType}
                setTitleDesktop={this.setTitleDesktop}
                setTitleMobile={setTitleMobile}
                surveyToShow={surveyToShow || 'default'}
                showThankYouExp={showThankYouExp}
                className='listing-draft-no-phone-container'
                onClose={onSurveyClose}
                isGemstone={isGemstone}
                defaultAnswers={defaultAnswers}
            />
            {/*{this.isMobile ? null : <img className={'survey-popup-partners'} src={imageUrl('trust-logos.png')} alt="Our partners"/>}*/}
        </div>;
    }
}

SurveyPopup.defaultProps = {
    popupClassName: `popup-survey-${isMobile() ? 'mobile' : 'desktop'}`,
    single: true,
    modal: true,
    forcePushState: true,
    onPopupClose: function() {
        this._onPopupClose();
    }
};

export default SurveyPopup
